import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore, createTransform } from 'redux-persist';
import createWebStorage from 'redux-persist/lib/storage/createWebStorage';
import { rootReducer } from './reducer';
import purgeMiddleware from './middleware/purgeMiddleware';
import {
  bootstrapTabSession,
  installTabCloseLogoutHandlers,
} from './utils/tabCloseLogout';

bootstrapTabSession();
installTabCloseLogoutHandlers();

const createPersistStorage = () => {
  if (typeof window === 'undefined') {
    return {
      getItem: async () => null,
      setItem: async () => undefined,
      removeItem: async () => undefined,
    };
  }
  return createWebStorage('session');
};

const AUTH_PERSIST_KEYS = [
    'name',
    'userId',
    'roleTypeId',
    'roleTypeName',
    'phoneNo',
    'email',
    'cnic',
    'code',
    'roleId',
    'roleName',
    'showAllApplicationsFlag',
    'cscID',
    'csc',
    'cfcLevelId',
    'cfcLevelName',
    'divisionCode',
    'circleCode',
    'companyCode',
    'selectedAdminCompanyCode',
    'hierarchy',
    'lastLoginTime',
    'userStatus',
    'currentDateTime',
    'profilePicture',
    'permissions',
    'token',
    'wmsPrivateToken',
];

const authPersistTransform = createTransform(
    (inboundState) => {
        if (!inboundState) return inboundState;
        const slim = {};
        AUTH_PERSIST_KEYS.forEach((key) => {
            if (inboundState[key] !== undefined) {
                slim[key] = inboundState[key];
            }
        });
        return slim;
    },
    (outboundState) => outboundState,
    { whitelist: ['auth'] },
);

const persistConfig = {
    key: 'root',
    storage: createPersistStorage(),
    whitelist: ['auth'],
    transforms: [authPersistTransform],
    throttle: 0,
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(purgeMiddleware),

})

export const persistor = persistStore(store)
